// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { CalendarEdit } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { icon1: CalendarEdit };

// ==============================|| MENU ITEMS - category ||============================== //

const Timetable: NavItemType = {
  id: 'TimetableNew',
  type: 'group',
  icon: icons.icon1,
  name: 'TimetableNew',
  children: [
    {
      icon: icons.icon1,
      id: 'TimetableNew',
      title: <FormattedMessage id="Timetable" />,
      type: 'collapse',
      children: [
        {
          icon: icons.icon1,
          id: 'TimetableNew',
          title: <FormattedMessage id="View Timetable" />,
          type: 'item',
          name: 'TimetableNew',
          url: '/timetableNew'
        },
        {
          icon: icons.icon1,
          id: 'Workload',
          title: <FormattedMessage id="Subject Workload" />,
          type: 'item',
          name: 'Workload',
          url: '/subjectworkload'
        },
        {
          icon: icons.icon1,
          id: 'Teacher Workload',
          title: <FormattedMessage id="Teacher Workload" />,
          type: 'item',
          name: 'Teacher Workload',
          url: '/teacherworkload'
        },
        {
          icon: icons.icon1,
          id: 'TimeOff',
          title: <FormattedMessage id="Time Off" />,
          type: 'item',
          name: 'TimeOff',
          url: '/timeOff'
        }
      ]
    }
  ]
};

export default Timetable;
